import React from 'react';
import {observable, action, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout, klaviyo_identify} from '../../../api';
import {CheckoutInputElement} from '../inputs/checkoutInputs';
import {getPhoneNumberFormatted, Portal} from '../../../util';

@observer
class OCIWrite extends React.Component {
    @observable loading: boolean = false;
    @observable tempValue: string = '1';
    @observable emailReadOnly: boolean = false;

    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
        this.handleOrderTypeChange = this.handleOrderTypeChange.bind(this);
        if (store.checkout.myframes_isDropShip) {
            this.tempValue = '1';
        } else {
            this.tempValue = '0';
        }
        makeObservable(this);
    }

    async componentDidMount() {
        this.tempValue = store.checkout.myframes_isDropShip ? '1' : '0';
    }

    @action
    handleOrderTypeChange = (e: any) => {
        this.tempValue = e.target.value;
        store.checkout.myframes_isDropShip = this.tempValue === '1';
        if (!store.checkout.myframes_isDropShip) {
            this.emailReadOnly = true;
            store.checkout.email.value = store.checkout.myframes_email;
            if (store.checkout.myframes_phone && store.checkout.myframes_phone.length > 0) {
                store.checkout.phone.value = store.checkout.myframes_phone;
            }
        }
    };

    @action
    save = async () => {
        this.loading = true;
        if (store.checkout.isMyFrames) {
            store.checkout.optIn = false;
            store.checkout.myframes_isDropShip = this.tempValue === '1';
            if (!store.checkout.myframes_isDropShip) {
                if (store.checkout.AddressBookAddresses && store.checkout.AddressBookAddresses.length > 0) {
                    let a = store.checkout.AddressBookAddresses.filter(x => x.isShipping);
                    if (a && a.length > 0) {
                        store.checkout.ship.AddressID = a[0].AddressID;
                        store.setShippingAddressToBook();
                    }

                    a = store.checkout.AddressBookAddresses.filter(x => x.isBilling);
                    if (a && a.length > 0) {
                        store.checkout.billing.AddressID = a[0].AddressID;
                        store.setShippingAddressToBook();
                    }
                }
            }
        }

        const success = await checkout('cc-oci-submit');
        runInAction(async () => {
            // approved ria
            this.loading = false;
            if (!store.checkout.isMyFrames) {
                await klaviyo_identify();
            }
        });
    };

    render() {
        return (
            <div>
                <div className="shipping-write">
                    <div className="checkout-padding checkout-border">
                        <div className="col-12 required">* Required</div>
                        {store.checkout.isMyFrames && (
                            <div className="row mb-3">
                                <div className="col-12 col-md-6">
                                    {/* MyFrames order type */}
                                    <div className="form-floating">
                                        <select
                                            id="myframes-order-type"
                                            name="myframes-order-type"
                                            aria-label="Select order type"
                                            className="form-select"
                                            onChange={this.handleOrderTypeChange}
                                            value={this.tempValue}
                                        >
                                            <option value="1">Drop Ship Order</option>
                                            <option value="0">Store Order</option>
                                        </select>
                                        <label htmlFor="myframes-order-type">Order Type</label>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    {/* MyFrames order type */}
                                    <CheckoutInputElement
                                        floating={true}
                                        o={store.checkout.myframes_po}
                                        required={true}
                                        ariaLabel="PO Number"
                                        ab={1}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12 col-md-6 pad-top">
                                <CheckoutInputElement
                                    ab={0}
                                    floating={true}
                                    o={store.checkout.email}
                                    readOnly={this.emailReadOnly}
                                    aria-label="Email"
                                    type="email"
                                    autoFocus={false}
                                    required={true}
                                    ariaLabel="Email"
                                />
                                {store.checkout.isMyFrames && this.emailReadOnly && <div className="hint">This email is the primary email address on file for your MyFrames account</div>}
                            </div>
                            <div className="col-12 col-md-6 pad-top">
                                <CheckoutInputElement
                                    ab={0}
                                    floating={true}
                                    o={store.checkout.phone}
                                    aria-label="Phone"
                                    type="tel"
                                    required={true}
                                    ariaLabel="Phone"
                                />
                            </div>

                            {store.checkout.messages
                                .filter(e => e.msgType === ICheckoutMessageType.oci)
                                .map(e => (
                                    <div className="col-12 pad-top">
                                        <div className="alert alert-danger">{e.msg}</div>
                                    </div>
                                ))}

                            <div className="col-12 f12">
                                <div className="pad-left privacy mt-3">
                                    <span style={{paddingRight: 6}}>
                                        <i
                                            className="fas fa-lock"
                                            aria-hidden={true}
                                        />
                                    </span>
                                    Your privacy is important to us. We use this information to contact you about your order if needed.
                                </div>
                                {!store.checkout.isMyFrames && (
                                    <div
                                        className="privacy mt-1"
                                        style={{paddingLeft: 7}}
                                    >
                                        <label className="radio-container">
                                            <input
                                                type="checkbox"
                                                className="radio radio-sm"
                                                name="payment-method"
                                                value={1}
                                                checked={store.checkout.optIn}
                                                onChange={() => (store.checkout.optIn = !store.checkout.optIn)}
                                            />
                                            <span className="radio-label">Keep me updated! I want to receive exclusive offers and promotions.</span>
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row mt-3">
                            {store.checkout.cstep === ICheckoutStep.oci && (
                                <>
                                    {store.checkoutABSkip === 2 && (
                                        <button
                                            type="button"
                                            className="link col-6"
                                            style={{fontSize: 13, marginLeft: 7, border: 'none', background: 'none', width: 'auto'}}
                                            onClick={() => store.moveStep(ICheckoutStep.checkout)}
                                        >
                                            Sign in to account
                                        </button>
                                    )}

                                    <div className="col-12 text-right">
                                        <div
                                            aria-live="assertive"
                                            aria-atomic="true"
                                            className="sr-only"
                                        >
                                            {this.loading ? 'Saving account data' : ''}
                                        </div>
                                        <button
                                            type="button"
                                            className={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                            onClick={this.save}
                                            aria-busy={this.loading}
                                            disabled={this.loading}
                                            aria-label={'Save and Continue'}
                                        >
                                            {!this.loading ? 'Save & Continue' : 'Saving'}
                                            {this.loading && (
                                                <span className="pad-left">
                                                    <i
                                                        className="fas fa-circle-notch fa-spin fast-spin fa-checkout-button"
                                                        aria-hidden={true}
                                                    ></i>
                                                </span>
                                            )}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

@observer
class OCIRead extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="checkout-padding checkout-border">
                <div className="row shipping-read-only gray">
                    <div className="col-12">
                        <span
                            className="form-inline-label"
                            style={{width: 50, display: 'inline-block'}}
                        >
                            Email
                        </span>
                        {store.checkout.email.value}
                        {!store.uiCheckout.processing && (
                            <span
                                className="pad-left link b pointer"
                                tabIndex={0}
                                onClick={() => store.moveStep(ICheckoutStep.oci)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        store.moveStep(ICheckoutStep.oci);
                                    }
                                }}
                            >
                                edit
                            </span>
                        )}
                    </div>
                    <div className="col-12">
                        <span
                            className="form-inline-label"
                            style={{width: 50, display: 'inline-block'}}
                        >
                            Phone
                        </span>
                        {getPhoneNumberFormatted(store.checkout.phone.value)}
                    </div>

                    {store.checkout.isMyFrames && (
                        <div className="col-12">
                            <span
                                className="form-inline-label"
                                style={{width: 50, display: 'inline-block'}}
                            >
                                Order Type
                            </span>
                            {store.checkout.myframes_isDropShip ? 'Drop Ship' : 'Store Order'}
                        </div>
                    )}
                    {store.checkout.isMyFrames && (
                        <div className="col-12">
                            <span
                                className="form-inline-label"
                                style={{width: 50, display: 'inline-block'}}
                            >
                                PO
                            </span>
                            {store.checkout.myframes_po.value}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

@observer
export default class OCI extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="oci">
                <div
                    className="checkout-header"
                    style={{color: Portal?.PortalID === 3 ? '#33393a' : '', backgroundColor: Portal?.PortalID === 3 ? '#edece9' : ''}}
                >
                    1. Order {!store.checkout.isMyFrames && 'Contact '}Information
                    {store.checkout.cstep > ICheckoutStep.oci && (
                        <button
                            className="shipping-edit-btn-header text-btn text-uppercase"
                            onClick={() => store.moveStep(ICheckoutStep.oci)}
                            type="button"
                            aria-label="Edit Order Contact Information"
                        >
                            Edit
                        </button>
                    )}
                    {store.checkout.cstep === ICheckoutStep.oci && (
                        <span
                            className="fas fa-caret-down"
                            aria-hidden={true}
                            style={{
                                fontSize: 20,
                                paddingRight: 12,
                                marginTop: 14,
                                float: 'right',
                                color: '#FFF',
                            }}
                        />
                    )}
                </div>
                {store.checkout.cstep === ICheckoutStep.oci && <OCIWrite />}
                {store.checkout.cstep > ICheckoutStep.oci && <OCIRead />}
            </div>
        );
    }
}
